import { render, staticRenderFns } from "./TransferToOdexModal.vue?vue&type=template&id=23082a0b&scoped=true&"
import script from "./TransferToOdexModal.vue?vue&type=script&lang=js&"
export * from "./TransferToOdexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23082a0b",
  null
  
)

export default component.exports